export default function Section12() {
    return (
      <section className="w-full bg-gray-50 py-16 px-6 md:px-12 lg:px-20 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Ready to Boost Your Email Marketing ROI?
          </h2>
          <p className="text-lg text-gray-600 mb-10">
            Partner with Mean3 to design personalized, automated email campaigns 
            that increase engagement, conversions, and revenue.
          </p>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <a
              href="https://mean3.com/contact-mean3/"
              className="bg-[#DA2128] text-white py-2 px-6 rounded-md font-semibold hover:bg-red-700 transition"
            >
              Book a Strategy Seesion
            </a>
           
          </div>
        </div>
      </section>
    );
  }
  